import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";

import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';

import { Checkbox } from "./UI";

import db from "../firebase";
import { doc, getDocs, collection, onSnapshot, setDoc, query, where, order, orderBy } from "firebase/firestore";

export default function AirdropAll ({saveAirdropAll, hideAirdropAll, project}) {
	const { register, handleSubmit, formState: { errors } } = useForm();
	const [message, setMessage] = useState('');
	const [airdropImage, setAirdropImage] = useState(null);
	const [imagePreview, setImagePreview] = useState(null);
	const [filterType, setFilterType] = useState('all');
	const [minPoints, setMinPoints] = useState(0);
	const [maxPoints, setMaxPoints] = useState(0);
	const [selectedActivity, setSelectedActivity] = useState('');

	const handleImageUpload = (e) => {
		const file = e.target.files[0];
		if (file) {
			setAirdropImage(file);
			const reader = new FileReader();
			reader.onloadend = () => {
				setImagePreview(reader.result);
			};
			reader.readAsDataURL(file);
		}
	};

	const removeImage = () => {
		setAirdropImage(null);
		setImagePreview(null);
	};

	const save = async (data) => {
		data['image'] = airdropImage;
		data['filterType'] = filterType;
		data['minPoints'] = minPoints;
		data['maxPoints'] = maxPoints;
		data['selectedActivity'] = selectedActivity;

		console.log(data);

		saveAirdropAll(data);
		hideAirdropAll();
	}

	return (
		<div className="wrapper">
			<div className="modal airdrop-all-modal">
				<h2>Send Airdrop to All Users</h2>
				<button className="close-button" onClick={hideAirdropAll}>&times;</button>

				<form onSubmit={handleSubmit(save)}>
					<div className="form-group">
						<label htmlFor="name">Airdrop Name</label>
						<input 
							id="name"
							type="text" 
							{...register("name", { required: "Airdrop name is required" })}
						/>
						{errors.name && <span className="error-message">{errors.name.message}</span>}
					</div>

					<div className="form-group">
						<label htmlFor="description">Description</label>
						<textarea 
							id="description"
							{...register("description", { required: "Description is required" })}
						/>
						{errors.description && <span className="error-message">{errors.description.message}</span>}
					</div>

					<div className="form-group">
						<label htmlFor="filterType">Filter Users</label>
						<select 
							id="filterType"
							onChange={(e) => setFilterType(e.target.value)} 
							value={filterType}
						>
							<option value="all">All Users</option>
							<option value="minPoints">Minimum Points</option>
							<option value="maxPoints">Maximum Points</option>
							<option value="activity">Completed Activity</option>
						</select>
					</div>

					{filterType === 'minPoints' && (
						<div className="form-group">
							<label htmlFor="minPoints">Minimum Points</label>
							<input 
								id="minPoints"
								type="number" 
								value={minPoints} 
								onChange={(e) => setMinPoints(e.target.value)}
							/>
						</div>
					)}

					{filterType === 'maxPoints' && (
						<div className="form-group">
							<label htmlFor="maxPoints">Maximum Points</label>
							<input 
								id="maxPoints"
								type="number" 
								value={maxPoints} 
								onChange={(e) => setMaxPoints(e.target.value)}
							/>
						</div>
					)}

					{filterType === 'activity' && (
						<div className="form-group">
							<label htmlFor="selectedActivity">Select Activity</label>
							<select 
								id="selectedActivity"
								onChange={(e) => setSelectedActivity(e.target.value)} 
								value={selectedActivity}
							>
								<option value="">Select an activity</option>
								{project.PACKETS.flatMap((packet, packetIndex) =>
									packet.activities.map((activity, activityIndex) => 
										activity && (
											<option key={`${packetIndex}-${activityIndex}`} value={`${packetIndex}-${activityIndex}`}>
												{packet.name} - {activity.name || `Activity ${activityIndex + 1}`}
											</option>
										)
									)
								)}
							</select>
						</div>
					)}

					<div className="form-group image-upload-group">
						<label htmlFor="airdropImage">Airdrop Image</label>
						<div className="image-upload-container">
							{imagePreview ? (
								<div className="image-preview">
									<img src={imagePreview} alt="Airdrop preview" />
									<button type="button" className="remove-image" onClick={removeImage}>
										Remove
									</button>
								</div>
							) : (
								<div className="upload-placeholder">
									<input
										id="airdropImage"
										type="file"
										accept="image/*"
										onChange={handleImageUpload}
										style={{ display: 'none' }}
									/>
									<label htmlFor="airdropImage" className="upload-button">
										Upload Image
									</label>
								</div>
							)}
						</div>
					</div>

					{message && <div className="error-message">{message}</div>}

					<div className="button-group">
                    <button type="submit" className="button primary-button">Send Airdrop</button>
                    <button type="button" className="button secondary-button" onClick={hideAirdropAll}>Cancel</button>
					</div>
				</form>
			</div>
		</div>
	)
}